import { throttle, addEventListener } from '@datadog/browser-core';
import { getNodePrivacyLevel } from '../privacy';
import { getSerializedNodeId, hasSerializedNode } from '../serialization';
import { getScrollX, getScrollY } from '../viewports';
import { NodePrivacyLevel } from '../../../constants';
import { getEventTarget } from './utils';
var SCROLL_OBSERVER_THRESHOLD = 100;
export function initScrollObserver(cb, defaultPrivacyLevel, elementsScrollPositions) {
    var updatePosition = throttle(function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var scrollPositions = target === document
            ? {
                scrollTop: getScrollY(),
                scrollLeft: getScrollX(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }, SCROLL_OBSERVER_THRESHOLD).throttled;
    return addEventListener(document, "scroll" /* DOM_EVENT.SCROLL */, updatePosition, { capture: true, passive: true }).stop;
}
//# sourceMappingURL=scrollObserver.js.map